import api from "./api";

export const forgotPassword = async (email: string) => {
  const response = await api.post("/auth/forgot-password", { email });
  return response.data;
};

export const verifyResetOtp = async (email: string, otp: string) => {
  const response = await api.post("/auth/verify-reset-otp", { email, otp });
  return response.data;
};

export const resetPassword = async (
  token: string,
  newPassword: string,
  confirmPassword: string
) => {
  const response = await api.post("/auth/reset-password", {
    token,
    newPassword,
    confirmPassword,
  });
  return response.data;
};

export const verifyMfaOtp = async (mfaToken: string, otp: string) => {
  const response = await api.post("/auth/mfa/verify-otp", { mfaToken, otp });
  return response.data;
};

export const resendMfaOtp = async (mfaToken: string) => {
  const response = await api.post("/auth/mfa/resend-otp", { mfaToken });
  return response.data;
};
